const purple = {
  100: '#9B5885'
};

export { purple };
